"use strict";
exports.__esModule = true;
exports.calculateInstallments = void 0;
var calculate_processing_fee_1 = require("./calculate-processing-fee");
var resolveSLCDayOffset = function (due_offset) {
    if (!due_offset) {
        return -1;
    }
    if (due_offset) {
        var day = due_offset.slice(due_offset.indexOf('P') + 1, due_offset.lastIndexOf('D'));
        if (day) {
            return parseInt(day) + 1;
        }
    }
    return -1;
};
var resolveSLCInstallments = function (installments, rentAmount, processingFeePercentage, propertyPassthroughFee, creditUtilizationCent) {
    var numberOfRepayments = installments.length - 1;
    // amounts
    var securedTotalAmount = creditUtilizationCent || 0;
    var firstPaymentAmount = rentAmount - securedTotalAmount;
    var secondPaymentAmount = securedTotalAmount / numberOfRepayments;
    // proportions
    var secondPaymentTotalProportion = (securedTotalAmount / rentAmount) * 100;
    var firstPaymentProportion = 100 - secondPaymentTotalProportion;
    var secondPaymentProportion = secondPaymentTotalProportion / numberOfRepayments;
    var propertyPassthroughFeeAmount = propertyPassthroughFee / numberOfRepayments;
    var processingFeeTotalAmount = (0, calculate_processing_fee_1.calculateProcessingFee)(processingFeePercentage, rentAmount);
    return installments
        .slice()
        .reverse()
        .map(function (installment, index) {
        var baseAmount = index === 0 ? firstPaymentAmount : secondPaymentAmount;
        var processingFeeAmount = index === 1 ? processingFeeTotalAmount : 0;
        var proportion = index === 0 ? firstPaymentProportion : secondPaymentProportion;
        var propertyPassthroughFeeForInstallment = index === 0 ? 0 : propertyPassthroughFeeAmount;
        return {
            day: resolveSLCDayOffset(installment.repayment_due),
            proportion: Number(proportion.toFixed(3)),
            baseAmount: baseAmount,
            processingFeeAmount: processingFeeAmount,
            processingFeePercentage: processingFeePercentage,
            totalAmount: baseAmount + processingFeeAmount + propertyPassthroughFeeForInstallment
        };
    });
};
var resolveDayOffset = function (due_offset) {
    if (!due_offset) {
        return -1;
    }
    var day = due_offset.slice(due_offset.indexOf('P') + 1, due_offset.lastIndexOf('D'));
    if (day) {
        return parseInt(day);
    }
    return -1;
};
var resolveInstallments = function (installments, rentAmount, processingFeePercentage, propertyPassthroughFee, creditUtilizationCent) {
    var numberOfRepayments = installments.length - 1;
    // amounts
    var repaymentTotalAmount = creditUtilizationCent || 0;
    var downpaymentAmount = rentAmount - repaymentTotalAmount;
    var repaymentAmount = repaymentTotalAmount / numberOfRepayments;
    // proportions
    var repaymentTotalProportion = (repaymentTotalAmount / rentAmount) * 100;
    var downpaymentProportion = 100 - repaymentTotalProportion;
    var repaymentProportion = repaymentTotalProportion / numberOfRepayments;
    var propertyPassthroughFeeAmount = propertyPassthroughFee / numberOfRepayments;
    return installments.map(function (installment) {
        var baseAmount = installment.due_offset === 'P0D' ? downpaymentAmount : repaymentAmount;
        var processingFeeAmount = (0, calculate_processing_fee_1.calculateProcessingFee)(processingFeePercentage, baseAmount);
        var proportion = installment.due_offset === 'P0D' ? downpaymentProportion : repaymentProportion;
        var propertyPassthroughFeeForInstallment = installment.due_offset === 'P0D' ? 0 : propertyPassthroughFeeAmount;
        return {
            day: resolveDayOffset(installment.due_offset),
            proportion: Number(proportion.toFixed(3)),
            baseAmount: baseAmount,
            processingFeeAmount: processingFeeAmount,
            processingFeePercentage: processingFeePercentage,
            totalAmount: baseAmount + processingFeeAmount + propertyPassthroughFeeForInstallment
        };
    });
};
/**
 * @deprecated Will no longer be usaed after we migrate all offers to have a fixed credit line
 */
var resolveLegacyInstallments = function (installments, rentAmount, processingFeePercentage) {
    return installments.map(function (installment) {
        var baseAmount = rentAmount * (installment.proportion / 100);
        var processingFeeAmount = (0, calculate_processing_fee_1.calculateProcessingFee)(processingFeePercentage, baseAmount);
        return {
            day: resolveDayOffset(installment.due_offset),
            proportion: installment.proportion,
            baseAmount: baseAmount,
            processingFeeAmount: processingFeeAmount,
            processingFeePercentage: processingFeePercentage,
            totalAmount: baseAmount + processingFeeAmount
        };
    });
};
var calculateInstallments = function (installments, rentAmount, processingFeePercentage, propertyPassthroughFee, creditUtilizationCent, isSLCOffer) {
    if (!(installments === null || installments === void 0 ? void 0 : installments.length) || !rentAmount) {
        return [];
    }
    if (isSLCOffer) {
        return resolveSLCInstallments(installments, rentAmount, processingFeePercentage, propertyPassthroughFee, creditUtilizationCent);
    }
    else {
        // If creditUtilizationCent is undefined it means offer is does not have a fixed credit line
        if (creditUtilizationCent === undefined || creditUtilizationCent === null) {
            return resolveLegacyInstallments(installments, rentAmount, processingFeePercentage);
        }
        return resolveInstallments(installments, rentAmount, processingFeePercentage, propertyPassthroughFee, creditUtilizationCent);
    }
};
exports.calculateInstallments = calculateInstallments;
